/**
 * Event Service
 * Historical events service API: a read-only record of what happened inside a Convercus loyalty program. It serves the stored event history for accounts, memberships and users, for coupons, for news posts and for workflows, filtered by subject, date range, originating user and event type. Every endpoint is a paginated read; the service never writes, edits or replays events.
 *
 * The version of the OpenAPI document: v1.0.37758
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RegistrationDto } from './registration-dto';


export interface UserRegistrationEventDto { 
    /**
     * Event ID
     */
    _id: string;
    /**
     * Program identifier
     */
    program: string;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Username
     */
    userName: string;
    /**
     * Event type
     */
    eventType: UserRegistrationEventDto.EventTypeEnum;
    /**
     * Interaction ID
     */
    interactionId: string;
    /**
     * User ID
     */
    userId: string;
    /**
     * User event type
     */
    userEventType: UserRegistrationEventDto.UserEventTypeEnum;
    /**
     * Subject information
     */
    subject: RegistrationDto;
}
export namespace UserRegistrationEventDto {
    export type EventTypeEnum = 'USER_CHANGED' | 'USER_CREATED' | 'REGISTRATIONDATA_CREATED' | 'REGISTRATIONDATA_DELETED' | 'CREDENTIALS_CHANGED' | 'CREDENTIALS_CREATED' | 'NEW_PASSWORD_REQUESTED' | 'NEW_REGISTRATION_REQUEST' | 'MEMBERSHIP_CHANGED' | 'MEMBERSHIP_CREATED' | 'MEMBERSHIP_OPTINS_CHANGED' | 'MEMBERSHIP_TERMINATED' | 'ACCOUNT_CREATED' | 'ACCOUNT_MERGED' | 'ACCOUNT_TERMINATED' | 'FRAUD_ADDED' | 'FRAUD_DELETED' | 'IDENTIFIER_ADDED' | 'IDENTIFIER_MERGED' | 'IDENTIFIER_REMOVED' | 'IDENTIFIER_UPDATED' | 'ACCOUNT_STATUS_LEVEL_CHANGED' | 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' | 'MEMBERSHIP_REMOVED';
    export const EventTypeEnum = {
        UserChanged: 'USER_CHANGED' as EventTypeEnum,
        UserCreated: 'USER_CREATED' as EventTypeEnum,
        RegistrationdataCreated: 'REGISTRATIONDATA_CREATED' as EventTypeEnum,
        RegistrationdataDeleted: 'REGISTRATIONDATA_DELETED' as EventTypeEnum,
        CredentialsChanged: 'CREDENTIALS_CHANGED' as EventTypeEnum,
        CredentialsCreated: 'CREDENTIALS_CREATED' as EventTypeEnum,
        NewPasswordRequested: 'NEW_PASSWORD_REQUESTED' as EventTypeEnum,
        NewRegistrationRequest: 'NEW_REGISTRATION_REQUEST' as EventTypeEnum,
        MembershipChanged: 'MEMBERSHIP_CHANGED' as EventTypeEnum,
        MembershipCreated: 'MEMBERSHIP_CREATED' as EventTypeEnum,
        MembershipOptinsChanged: 'MEMBERSHIP_OPTINS_CHANGED' as EventTypeEnum,
        MembershipTerminated: 'MEMBERSHIP_TERMINATED' as EventTypeEnum,
        AccountCreated: 'ACCOUNT_CREATED' as EventTypeEnum,
        AccountMerged: 'ACCOUNT_MERGED' as EventTypeEnum,
        AccountTerminated: 'ACCOUNT_TERMINATED' as EventTypeEnum,
        FraudAdded: 'FRAUD_ADDED' as EventTypeEnum,
        FraudDeleted: 'FRAUD_DELETED' as EventTypeEnum,
        IdentifierAdded: 'IDENTIFIER_ADDED' as EventTypeEnum,
        IdentifierMerged: 'IDENTIFIER_MERGED' as EventTypeEnum,
        IdentifierRemoved: 'IDENTIFIER_REMOVED' as EventTypeEnum,
        IdentifierUpdated: 'IDENTIFIER_UPDATED' as EventTypeEnum,
        AccountStatusLevelChanged: 'ACCOUNT_STATUS_LEVEL_CHANGED' as EventTypeEnum,
        AccountCustomPropertyChanged: 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' as EventTypeEnum,
        MembershipRemoved: 'MEMBERSHIP_REMOVED' as EventTypeEnum
    };
    export type UserEventTypeEnum = 'USER_CHANGED' | 'USER_CREATED' | 'REGISTRATIONDATA_CREATED' | 'REGISTRATIONDATA_DELETED' | 'CREDENTIALS_CHANGED' | 'CREDENTIALS_CREATED' | 'NEW_PASSWORD_REQUESTED' | 'NEW_REGISTRATION_REQUEST' | 'MEMBERSHIP_CHANGED' | 'MEMBERSHIP_CREATED' | 'MEMBERSHIP_OPTINS_CHANGED' | 'MEMBERSHIP_TERMINATED' | 'ACCOUNT_CREATED' | 'ACCOUNT_MERGED' | 'ACCOUNT_TERMINATED' | 'FRAUD_ADDED' | 'FRAUD_DELETED' | 'IDENTIFIER_ADDED' | 'IDENTIFIER_MERGED' | 'IDENTIFIER_REMOVED' | 'IDENTIFIER_UPDATED' | 'ACCOUNT_STATUS_LEVEL_CHANGED' | 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' | 'MEMBERSHIP_REMOVED';
    export const UserEventTypeEnum = {
        UserChanged: 'USER_CHANGED' as UserEventTypeEnum,
        UserCreated: 'USER_CREATED' as UserEventTypeEnum,
        RegistrationdataCreated: 'REGISTRATIONDATA_CREATED' as UserEventTypeEnum,
        RegistrationdataDeleted: 'REGISTRATIONDATA_DELETED' as UserEventTypeEnum,
        CredentialsChanged: 'CREDENTIALS_CHANGED' as UserEventTypeEnum,
        CredentialsCreated: 'CREDENTIALS_CREATED' as UserEventTypeEnum,
        NewPasswordRequested: 'NEW_PASSWORD_REQUESTED' as UserEventTypeEnum,
        NewRegistrationRequest: 'NEW_REGISTRATION_REQUEST' as UserEventTypeEnum,
        MembershipChanged: 'MEMBERSHIP_CHANGED' as UserEventTypeEnum,
        MembershipCreated: 'MEMBERSHIP_CREATED' as UserEventTypeEnum,
        MembershipOptinsChanged: 'MEMBERSHIP_OPTINS_CHANGED' as UserEventTypeEnum,
        MembershipTerminated: 'MEMBERSHIP_TERMINATED' as UserEventTypeEnum,
        AccountCreated: 'ACCOUNT_CREATED' as UserEventTypeEnum,
        AccountMerged: 'ACCOUNT_MERGED' as UserEventTypeEnum,
        AccountTerminated: 'ACCOUNT_TERMINATED' as UserEventTypeEnum,
        FraudAdded: 'FRAUD_ADDED' as UserEventTypeEnum,
        FraudDeleted: 'FRAUD_DELETED' as UserEventTypeEnum,
        IdentifierAdded: 'IDENTIFIER_ADDED' as UserEventTypeEnum,
        IdentifierMerged: 'IDENTIFIER_MERGED' as UserEventTypeEnum,
        IdentifierRemoved: 'IDENTIFIER_REMOVED' as UserEventTypeEnum,
        IdentifierUpdated: 'IDENTIFIER_UPDATED' as UserEventTypeEnum,
        AccountStatusLevelChanged: 'ACCOUNT_STATUS_LEVEL_CHANGED' as UserEventTypeEnum,
        AccountCustomPropertyChanged: 'ACCOUNT_CUSTOM_PROPERTY_CHANGED' as UserEventTypeEnum,
        MembershipRemoved: 'MEMBERSHIP_REMOVED' as UserEventTypeEnum
    };
}


